import { render, staticRenderFns } from "./SmallWidget.vue?vue&type=template&id=1c3a7012&scoped=true"
import script from "./SmallWidget.vue?vue&type=script&lang=js"
export * from "./SmallWidget.vue?vue&type=script&lang=js"
import style0 from "./SmallWidget.vue?vue&type=style&index=0&id=1c3a7012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a7012",
  null
  
)

export default component.exports